import Joi from 'joi';
import { LookupListApiItem } from '../../../../../api/user/model';
import { getEmailSchema, getNricFinJoiObject } from '../../../../../utils/JoiUtils';

export interface RetrieveAppealRegistrationFormData {
  IdType: string;
  uinFinPassport: string;
  school: LookupListApiItem;
  examYear: number;
  email: string;
}

export const schemaRetrieveAppealRegistrationDetails = Joi.object<RetrieveAppealRegistrationFormData>({
  IdType: Joi.string().required().messages({
    'any.required': 'Please select an ID type',
    'string.base': 'Please select an ID type',
  }),
  uinFinPassport: getNricFinJoiObject(),
  school: Joi.object().required().messages({
    'any.required': 'Please select a school',
    'object.base': 'Please select a school',
  }),
  examYear: Joi.number().required().messages({
    'any.required': 'Please select an exam year',
    'number.base': 'Please select an exam year',
  }),
  email: getEmailSchema('Email'),
});
